
import Vue from 'vue'
import { CheckoutPageModel } from '@ViewModels/CheckoutPageModel'
import { StoreCheckoutDto } from '@ViewModels/StoreCheckoutDto'
import ShippingAddress from './ShippingAddress.vue'
import SelectionAccordion, { SelectionAccordionOption } from '../SelectionAccordion.vue'
import ClickAndCollectAddress from './ClickAndCollectAddress.vue'
import SchoolAddress from './SchoolAddress.vue'

export default Vue.extend({
   name: 'DeliveryMethod',
   computed: {
      modelData(): CheckoutPageModel {
         return this.$store.state.modelData
      },
      purchase(): StoreCheckoutDto {
         return this.$store.state.purchase
      },
      isSchoolOrder(): boolean {
         return !this.purchase.IsPersonalOrder
      },
      isPersonalOrder(): boolean {
         return this.$store.state.purchase.IsPersonalOrder
      },
      isClickAndCollect(): boolean {
         return this.$store.state.purchase.ClickAndCollect
      },
      allowClickAndCollect(): boolean {
         return this.$store.state.purchase.ClickAndCollect
      },
      deliveryMethod(): string {
         return this.isClickAndCollect ? 'clickandcollect' : 'delivery'
      },
      deliveryMethodOptions(): SelectionAccordionOption[] {
         const options = []

         if (this.isSchoolOrder) {
            options.push({ name: 'Deliver', value: 'delivery', component: SchoolAddress })
         } else {
            options.push({ name: 'Deliver', value: 'delivery', component: ShippingAddress })
         }

         if (this.allowClickAndCollect) {
            options.push({ name: 'Click and Collect (free)', value: 'clickandcollect', component: ClickAndCollectAddress })
         }

         return options
      },
      showErrors(): boolean {
         return this.$store.state.showErrors
      },
   },
   methods: {
      setDeliveryMethodOption(option: string) {
         this.setDeliveryMethod(option === 'clickandcollect')
      },
      setDeliveryMethod(clickAndCollect: boolean) {
         this.$store.dispatch('setDeliveryMethod', clickAndCollect)
      },
   },
   components: {
      SelectionAccordion,
      ClickAndCollectAddress,
      SchoolAddress
   },
})
